module.exports = __webpack_public_path__ + "static/media/get-plan-instruction.9d72c36c.svg";